import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/common/auth/auth.service';

@Component({
  selector: "app-all-apps",
  templateUrl: "./all-apps.component.html",
  styleUrls: ["./all-apps.component.css"],
})
export class AllAppsComponent implements OnInit {

  currentUser: any;

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.authService.currentUser$.subscribe((user) => {
      this.currentUser = user;
    });
  }

  openExternalRedirectApp(app) {
    switch (app.label) {
    }
  }

  openExternalApp(url) {
    let tab = window.open("", "_blank");
    tab.location.href = url;
  }

  navigate(app) {
    switch (app.type) {
      case 'iframes':
      case 'applications':
        this.router.navigate([app.url]);
        break;
      case 'external':
        this.openExternalApp(app.url);
        break;
      case 'external-redirect':
        this.openExternalRedirectApp(app);
        break;
    }
  }
}
